import { ICONS } from "../../common/constants";
import { MessagesProps } from "../../common/types";
import styles from "./Message.module.scss";
import Markdown from "../../common/components/Markdown";
import { FaRegCopy } from "react-icons/fa";
import { copyContents } from "../../common/helpers";
import { RxReload } from "react-icons/rx";

var points: any[] = [];
const coordinates: any = { latitude: "", longitude: "" };

const detectValueType = (value: any) => {
  if (typeof value === "object" && value instanceof Array) {
    return destructureArrayToString(value);
  } else if (typeof value === "object") {
    return destructureArrayToString([value]);
  } else {
    return value;
  }
};

const destructureArrayToString = (contentArray: any[]) => {
  return (
    <div>
      {contentArray.map((arrItem, index) => (
        <ul key={`contentArray-${index}`}>
          {typeof arrItem === "string" || typeof arrItem === "number" ? (
            <li>{arrItem} </li>
          ) : (
            <>
              {Object.entries(arrItem).map(([key, value]: any[], index) => {
                if (key === "longitude") {
                  coordinates[key] = value;
                } else if (key === "latitude") {
                  coordinates[key] = value;
                }

                if (coordinates?.latitude && coordinates?.longitude) {
                  if (points.length === 0) {
                    points.push(coordinates);
                  }
                }
                return (
                  <li key={`location-${index}`}>
                    {key}:{detectValueType(value)}
                  </li>
                );
              })}
            </>
          )}
        </ul>
      ))}
    </div>
  );
};

const Message = ({ content }: { content: MessagesProps }) => {
  return (
    <main className={styles.container}>
      <section>
        {content.user && (
          <section className={styles.flex}>
            <span className={`material-symbols-outlined  ${styles.ml5}`}>
              {ICONS.PERSON}
            </span>
            <p className={`${styles.text} `}> {content.user} </p>
          </section>
        )}

        {content?.response && (
          <section className={styles.flex}>
            <article className={`material-symbols-outlined ${styles.logo}`}>
              {ICONS.REAL_ESTATE_AGENT}
            </article>
            <pre>
              <Markdown>{content.response}</Markdown>
            </pre>
            <div className={styles.copyWrapper}>
              <article>
                <FaRegCopy onClick={() => copyContents(content.response)} />
              </article>
              <article onClick={()=>window.location.reload()}>
                <RxReload />
              </article>
            </div>
          </section>
        )}
      </section>
    </main>
  );
};

export default Message;
